<template>
  <PosView />
</template>

<script>
import PosView from '@/views/admin/pos/Pos.vue';

export default {
  name: 'OperadorPos',
  components: { PosView },
};
</script>
